import { Building2, User, ArrowRight } from "lucide-react";
import { Reveal } from "../site/Motion";
import { SectionLabel } from "../site/Bits";
import { APP_SCREENSHOTS } from "../../lib/site";

const cards = [
  {
    icon: Building2,
    tag: "For SMBs",
    title: "Small & medium businesses",
    desc: "Centralise fleet insurance, staff certifications, business licences, equipment warranties and vendor contracts. Keep the whole operation compliant without the spreadsheets.",
    img: APP_SCREENSHOTS.smb_owner_1,
    points: ["Team-wide renewal visibility", "Reduce compliance risk & fines", "Never disrupt operations"],
  },
  {
    icon: User,
    tag: "For individuals",
    title: "Personal organisation",
    desc: "Keep your passport, driving licence, car insurance, warranties and subscriptions in one tidy place — with friendly reminders before anything runs out.",
    img: APP_SCREENSHOTS.smb_owner_2,
    points: ["All personal documents in one app", "Timely renewal reminders", "Simple and stress-free"],
  },
];

export const WhoIsItFor = () => (
  <section id="who" className="relative scroll-mt-24 bg-background py-24" data-testid="who-section">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <Reveal className="max-w-2xl">
        <SectionLabel>Who is it for?</SectionLabel>
        <h2 className="mt-5 font-display text-4xl font-bold leading-tight tracking-tight text-ink sm:text-5xl">
          Built for business. Loved by individuals.
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-6 lg:grid-cols-2">
        {cards.map((c, i) => (
          <Reveal key={c.title} delay={i * 0.12}>
            <div
              data-testid={`who-card-${i}`}
              className="group h-full overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-sm transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-xl"
            >
              <div className="relative h-52 overflow-hidden">
                <img src={c.img} alt={c.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-t from-ink/70 to-transparent" />
                <span className="absolute left-5 top-5 inline-flex items-center gap-2 rounded-full bg-white/90 px-3 py-1 text-xs font-semibold text-brand">
                  <c.icon className="h-3.5 w-3.5" /> {c.tag}
                </span>
              </div>
              <div className="p-8">
                <h3 className="font-display text-2xl font-semibold text-ink">{c.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-600">{c.desc}</p>
                <ul className="mt-5 space-y-2">
                  {c.points.map((p) => (
                    <li key={p} className="flex items-center gap-2 text-sm font-medium text-slate-700">
                      <ArrowRight className="h-4 w-4 text-greenaccent" /> {p}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default WhoIsItFor;
